import React from 'react';
import { CheckCircleIcon, ExclamationCircleIcon, XCircleIcon, MinusCircleIcon } from '@heroicons/react/24/solid';

interface GoalOutcomeIconProps {
  outcome?: string | null;
  size?: string;
  showLabel?: boolean;
}

const OUTCOME_CONFIG: Record<string, { icon: React.ElementType; color: string; label: string }> = {
  achieved:       { icon: CheckCircleIcon,       color: 'text-emerald-400', label: 'Achieved' },
  partial:        { icon: ExclamationCircleIcon,  color: 'text-yellow-400',  label: 'Partial' },
  no_progress:    { icon: XCircleIcon,            color: 'text-red-400',     label: 'No Progress' },
  not_applicable: { icon: MinusCircleIcon,        color: 'text-slate-500',   label: 'N/A' },
};

const GoalOutcomeIcon: React.FC<GoalOutcomeIconProps> = ({ outcome, size = 'h-4 w-4', showLabel = false }) => {
  if (!outcome) return null;
  const config = OUTCOME_CONFIG[outcome];
  if (!config) return null;

  const Icon = config.icon;
  return (
    <span className={`inline-flex items-center gap-1 ${config.color}`}>
      <Icon className={size} />
      {showLabel && <span className="text-xs font-medium">{config.label}</span>}
    </span>
  );
};

export default GoalOutcomeIcon;
